module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_26_LICZEBNIKI_1_A.0f65b4da.mp3";